import HomeV2 from './HomeV2';

export default function Index() {
  return <HomeV2 />;
}
